import { useDocumentForEsigning } from 'app/domains/esigning/hooks/useDocumentForEsigning';
import { useEsigningProviders } from 'app/domains/esigning/hooks/useEsigningProviders';
import { useGetSignRequestAttachments } from 'app/domains/esigning/hooks/useGetSignRequestAttachments';
export function useEsigningLoadingState() {
    const { loading: loadingDocumentSupport } = useDocumentForEsigning();
    const { loading: loadingAttachments } = useGetSignRequestAttachments();
    const { loading: loadingEsigningProviders } = useEsigningProviders();
    return loadingDocumentSupport || loadingEsigningProviders || loadingAttachments;
}
